module.exports = __webpack_public_path__ + "img/recs_1.7dfdff7a.png";